/* eslint-disable react-hooks/exhaustive-deps */
import { appRoute } from "routes/app/home.runtime"
import ScheduleDisplay from "routes/schedule/scheduleDisplay"
import Schedules from "routes/schedule/schedules"
import "./remove-task"
import "./time-line"
import "./timeline-button"
import "./delete-button"
import "./publish-button"
import "./preview-button"
import { defineStateProperties } from "library/behaviours/index.mjs"
import { ScheduleEdit } from "routes/schedule/edit/schedule-edit"
import { Review } from "routes/schedule/edit/review"
import { Bound } from "lib/@components/binding/Bound"
import { Rejection } from "routes/schedule/edit/rejection"
import { AuditEntryBelow, AuditEntryTop, CompareTitleTop } from "slot-definitions"
import { ShowCustomScheduleReason } from "routes/plan/plugins/show-activity/plan-show-activity.runtime"
import { ApprovalMethod } from "./approval-method"
import { ReviewAudit } from "routes/asset-register/plugins/general-tailoring/plugins/tailored-change-review/review-audit"
import { ScheduleAuditLabel } from "./schedule-audit-label"
import { FormatAuditData } from "event-definitions"
import { cleanDataFromOmittedInPlace } from "./clean-data-from-omitted-in-place"
import { normaliseCustomScheduleAuditFrequency } from "./normalise-audit-frequency"
import { TitleNewOrRemoved } from "routes/audit/component/title-new-or-removed"
import { DraftJustification } from "../compare/draft-justification"

appRoute.register(
    "schedules/:id/edit",
    <Schedules>
        <ScheduleEdit $lazy />
    </Schedules>
)

appRoute.register(
    "schedules/:id/preview",
    <Schedules>
        <ScheduleEdit $lazy preview={true} />
    </Schedules>
)
AuditEntryBelow("customSchedule").plug(<ShowCustomScheduleReason priority={100} />)
AuditEntryBelow("customSchedule").plug(<ApprovalMethod />)
AuditEntryBelow("customSchedule").plug(<ReviewAudit />)
AuditEntryBelow("customSchedule").plug(<ScheduleAuditLabel />)
AuditEntryTop("customSchedule").plug(<TitleNewOrRemoved />)
CompareTitleTop.plug(<DraftJustification if={(c) => c.editMode && !c.isAuthoringScheduleEditor} />)

FormatAuditData("customSchedule").handle(normaliseCustomScheduleAuditFrequency)
FormatAuditData("customSchedule").handle(cleanDataFromOmittedInPlace)

export const states = defineStateProperties({
    default: (
        <>
            <Rejection />
            <ScheduleDisplay />
        </>
    ),
    review: (
        <Bound canUndo={false} canRedo={false}>
            <Review />
        </Bound>
    ),
})
